import { Injectable } from '@angular/core';
import { Permission } from '@models/permission.model';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    private permissions: Permission[];

    constructor() {}

    setPermissions(permissions: Permission[]): void {
        this.permissions = permissions;
    }

    public get permissionsValue(): Permission[] {
        return this.permissions;
    }

    hasPermissions(
        userPermissions: Permission[],
        permissions: string[]
    ): boolean {
        return userPermissions.find((perm: Permission) =>
            permissions.includes(perm.permission_type)
        )
            ? true
            : false;
    }
}
